<template>
    <ModalComponent
        :name="'editar-' + categoria.id"
        :title="'Editar categoría ' + categoria.name"
        v-on:close="() => close(false)"
        v-if="!loading"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormCategoria :categoria="categoria" @terminado="editar"/>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
    <LoaderComponent v-else/>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormCategoria from '@/components/backend/bases/categorias/FormCategoria';

    export default {
        props: ['categoria'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close() {                
                this.$emit('close', 'editar-' + this.categoria.id);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.editar();
                }
            },
            editar() {
                this.loading = true;

                if (!this.categoria.activar_pago_plazos) {
                    this.categoria.min_cantidad_plazos = '';
                    this.categoria.max_cantidad_plazos = '';
                    this.categoria.frecuencias = [];
                }

                var params = {
                    lista_id: this.lista_id,
                    name: this.categoria.name,
                    precio: this.categoria.precio,
                    observacion_indumentarias: this.categoria.observacion_indumentarias,
                    indumentariasSelect: this.categoria.indumentariasSelect,
                    activar_pago_plazos: this.categoria.activar_pago_plazos,
                    min_cantidad_plazos: this.categoria.min_cantidad_plazos,
                    max_cantidad_plazos: this.categoria.max_cantidad_plazos,
                    frecuencias: this.categoria.frecuencias,
                    categoria_id: this.categoria.id,
                    taquilla: this.categoria.taquilla,
                    online: this.categoria.online,
                    filters : {}
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.editar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message, {});
                    this.close();
                }).catch(error => {
                    if (error.response.data.errors) {
                        if (error.response.data.errors.name) {
                            this.$toast.error(error.response.data.errors.name.toString(), {});
                        } else {
                            this.$toast.error(error.response.data.errors.precio.toString(), {});
                        }
                    } else {
                        this.$toast.error(error.response.data.message, {});
                    }

                    this.$emit('actualizar');
                }).finally(() => this.loading = false);
            },
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: {
            ModalComponent, FormCategoria
        }
    }
</script>
